/** Created by azhou on 2019/3/19.*/
<template>
  <div>
    <public-title>{{(ticketId>0 ? '编辑':'添加')+'门票种类'}}
      <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <div class="bg-white p-5">
      <div class="d-center-start mb-3" v-if="!brand">
        <left-text leftText="门票类别"/>
        <el-radio-group v-model="ticketType">
          <el-radio :label="item.id" :key="item.name" v-for="item in $GVAR.ticketTopType.slice(0,2)">{{item.name}}</el-radio>
        </el-radio-group>
      </div>
      <div class="d-center-start mb-3">
        <left-text leftText="票种"/>
        <el-radio-group v-model="ticketSpecie">
          <el-radio class="mb-0" :label="item.id" :key="item.name" v-for="item in $GVAR.ticketTypeArr">
            {{item.name}}
          </el-radio>
        </el-radio-group>
      </div>
      <left-text-border class="mb-3" :leftText="brand ? '活动名称' : '门票名称'" v-model="ticketName"/>
      <div class="d-center-start mb-3">
        <left-text leftText="排序"/>
        <el-input-number size="small" v-model="sort" :min="1" />
        <span class="text-danger h6 ml-3">(数值越大，排名越靠前)</span>
      </div>
      <div class="d-center mb-3" v-if="brand">
        <left-text :leftText="(brand ? '活动' : '门票')+'价格'" required/>
        <p class="w-50 text-center border-bottom-primary pb-1">
          <span class="text-primary">星期日</span><span class="text-danger ml-small mr-small">至</span>
          <span class="text-primary">星期四</span><span class="text-danger">（非周末）</span>
        </p>
        <p class="w-50 text-center border-bottom-primary pb-1">
          <span class="text-primary">星期五、星期六</span>
          <span class="text-danger">（周末）</span>
        </p>
      </div>
      <div v-if="brand" class="mb-2">
        <div class="d-center-start mb-3" v-for="(item,index) in roomPrice" :key="index">
          <left-text :leftText="item.text" required />
          <p class="w-50 text-center border-bottom-primary pb-1">
            <el-input v-model="bPrice[item.noweek]" placeholder="输入非周末价格">
              <span slot="append" class="text-dark">元</span>
            </el-input>
          </p>
          <p class="w-50 pl-2 text-center border-bottom-primary pb-1">
            <el-input v-model="bPrice[item.week]" placeholder="输入周末价格">
              <span slot="append" class="text-dark">元</span>
            </el-input>
          </p>
        </div>
      </div>
      <div class="mb-3 d-center-between flex-wrap" v-else>
        <div class="d-center-between mb-2 text-right" v-for="item in priceArr" :key="item.value">
          <left-text :leftText="item.title"/>
          <div class="bg-white">
            <!-- <span class="text-blue border-right pl-3 pr-3 mr-2">&yen;</span> -->
            <input type="number" class="price-input border pl-3" v-model="price[item.value]">
            <span class="bg-base p-2">元 / 人</span>
            <span v-if="item.title == '佣金'">
              <el-tooltip class="item" effect="dark" content="景区提现时所要扣除的部分" placement="top">
                <i class="el-icon-info text-info ml-1"></i>
              </el-tooltip>
            </span>
            <span v-if="item.title == '在线立减'">
              <el-tooltip class="item" effect="dark" content="用户在购买门票时，采购商价 - 在线立减 = 门票价格" placement="top">
                <i class="el-icon-info text-info ml-1"></i>
              </el-tooltip>
            </span>
          </div>
        </div>
      </div>
      <div class="d-center-start mb-3" v-if="userInfo.type === 99">
        <left-text leftText="签约折扣" />
        <el-switch  v-model="value"  active-color="#10c568"  inactive-color="#919191"  active-value="1"  inactive-value="0" />
      </div>
      <div v-if="!brand">
        <div class="d-center-start mb-3"><left-text leftText="场次"/></div>
        <div class="add d-center-center ml-2" v-show="!showplay" @click="showplay = true">+</div>
        <div v-show="showplay" class="text-left mb-3 ml-2">
          <el-time-picker
            v-model="playtime"
            size="small"
            format="HH:mm"
            placeholder="请选择场次时间">
          </el-time-picker>
          <span class="text-link ml-3" @click="handleInputConfirm">添加</span>
          <div>
            <el-tag
              class="mt-2 mr-2"
              v-for="(tag, index) in dynamicTags"
              :key="index"
              closable
              effect="plain"
              :disable-transitions="false"
              @close="handleClose(tag)">{{tag}}</el-tag>
          </div>
        </div>
      </div>
      <div v-if="ticketType == '2'">
        <div class="d-center-start mb-3"><left-text leftText="座位区域"/></div>
        <div class="add ml-2" v-show="!showseat" @click="showseat = true">+</div>
        <div v-show="showseat" class="mb-3">
          <div class="text-left ml-2">
            <el-input placeholder="如：前排VIP" class="w-30" size="small" v-model="seatName"><template slot="prepend">位置名称：</template></el-input>
            <span class="text-link ml-3" @click="addSeat">确认添加</span>
          </div>
          <div class="d-center-between flex-wrap mt-3">
            <div class="d-center-between text-right" v-for="item in seatArr" :key="item.value">
              <left-text :leftText="item.title"/>
              <div class="bg-white">
                <input type="number" class="price-input border pl-3" v-model="price[item.value]">
                <span class="bg-base p-2">元 / 人</span>
              </div>
            </div>
          </div>
          <el-table  :data="tableData" v-show="tableData.length > 0" class="border mt-5 specialDis" style="width: 100%">
            <el-table-column label="位置名称">
              <template slot-scope="scope">
                <el-input size="small" :disabled="!scope.row.edit" v-model="scope.row.seat_name" />
              </template>
            </el-table-column>
            <el-table-column label="门市价">
              <template slot-scope="scope">
                <el-input size="small" :disabled="!scope.row.edit" v-model="scope.row.price1" />
              </template>
            </el-table-column>
            <el-table-column label="网络价">
              <template slot-scope="scope">
                <el-input size="small" :disabled="!scope.row.edit" v-model="scope.row.price2" />
              </template>
            </el-table-column>
            <el-table-column label="采购商价">
              <template slot-scope="scope">
                <el-input size="small" :disabled="!scope.row.edit" v-model="scope.row.price3" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="text-link mr-2" v-show="!scope.row.edit" @click="scope.row.edit = true">编辑</span>
                <span class="text-link mr-2" v-show="scope.row.edit" @click="rowSave(scope.row)">保存</span>
                <span class="text-link" @click="tableData.splice(scope.$index, 1)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="d-center-start mb-3 mt-3"><left-text leftText="上传座位图"/></div>
          <upload-image @fileChange="(imgs)=>{this.InsideImgs = imgs;}" class="ml-2"
                        :existImgs="InsideImgs" :maxLength="5" editMode/>
        </div>
      </div>
      <!-- 品牌馆区别 -->
      <div v-if="brand">
        <div class="mb-3 d-start-start">
            <left-text leftText="状态"/>
            <label>
              <el-radio v-model="bstatus" label="1">启用</el-radio>
              <el-radio v-model="bstatus" label="0">禁用</el-radio>
            </label>
        </div>
        <div class="d-flex align-items-start mb-3">
          <left-text-border leftText="活动介绍" placeholder="该活动项目具体内容描述..." class="w-100"
            required v-model="introduce" type="textarea"/>
        </div>
        <div class="mb-2 d-start-start">
          <left-text leftText="活动相册" required/>
          <upload-image @fileChange="(imgs)=>pics = imgs"  :existImgs="pics" :maxLength="5" editMode/>
        </div>
      </div>
      <div class="d-flex align-items-start mb-3" v-for="item in tipArr" :key="item.value">
        <left-text-border :leftText="item.title" :placeholder="item.placeholder" class="w-100"
                          required v-model="tips[item.value]" type="textarea"/>
      </div>
      <el-button type="success" @click="submitForm" v-if="showSubmitBtn">{{isAdmin?'审核通过':'确认提交'}}</el-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  export default {
    name: 'addEditTicket',
    computed: {
      ...mapState(['ticketDetail']),
      ...mapGetters(['userInfo', 'isAdmin','brand']),
      ticketId () { return this.$route.query.id },
      priceArr () {
        let arr = [
          { title: '门市价', value: 'price1' },
          { title: '网络价', value: 'price2' },
          { title: '采购商价', value: 'price3' },
        ]
        if (this.ticketType == '1' && !this.brand) { arr.splice(1,1) }
        if (this.userInfo.type === 99) {
          arr = arr.concat([{ title: '佣金', value: 'poundage' }, { title: '在线立减', value: 'discount' }])
        }
        if (this.brand) { arr[1].title='采购商价'; arr[2].title = '订单雨价' }
        return arr
      },
      showSubmitBtn() {
        let t = this.userInfo.type;
        return t !== 99 || (t === 99 && this.ticketDetail.is_verify !== '1')
      },
      roomPrice() {
        return [
          {text: '门市价',noweek: 'price1',week: 'price01'},
          {text: '采购商价',noweek: 'price2',week: 'price02'},
          {text: '订单雨价',noweek: 'price3',week: 'price03'}
        ]
      }
    },
    watch:{
      ticketDetail(newVal) {
        this.ticketType = newVal.ticket_type;
        this.ticketSpecie = Number(newVal.ticket_species) || Number(newVal.species);
        if (this.ticketType == '2') this.InsideImgs = newVal.seat_pic.split(',');
        if(!this.brand){
          if (newVal.scene_arr.length > 0) this.showplay = true;
          if (newVal.seat_arr.length > 0 || newVal.seat_pic.length > 0) this.showseat = true
          this.dynamicTags = newVal.scene_arr.map(v => v.date);
          this.tableData = newVal.seat_arr.map(v => { return {...v, edit: false} });
        } else {
          this.introduce = newVal.content
          this.bstatus = String(newVal.status)
          this.pics = newVal.pic.split(',')
          this.sort = newVal.sort
        }
        this.ticketName = newVal.name;
        this.value = String(newVal.is_discount);
        let price = this.brand ? this.bPrice : this.price
        for (let key in price) price[key] = newVal[key];
        for (let key in this.tips) this.tips[key] = newVal[key];
      }
    },
    created() {
      if (this.ticketId) this.getTicketDetail(this.ticketId);
    },
    data () {
      return {
        tipArr: [ 
          { title: '费用包含', value: 'description1', placeholder: '如：门票一张' },
          { title: '入园方式', value: 'description2', placeholder: '如：凭景区短信二维码入园' },
          { title: '重要提示', value: 'description3', placeholder: '如：本产品不支持部分退款' },
          { title: '退改规则', value: 'description4', placeholder: '如：逾期不可退票。本商品不支持部分退' },
        ],
        seatArr: [
          { title: '门市价', value: 'sprice1' },
          { title: '网络价', value: 'sprice2' },
          { title: '采购商价', value: 'sprice3' },
        ],
        InsideImgs:[],
        ticketType: '1',
        ticketSpecie: 1,
        ticketName: '',
        showplay: false,
        showseat: false,
        seatName: '',
        playtime: new Date(2019, 6, 1, 10, 30),
        dynamicTags: [],
        tableData: [],
        value: '1',
        introduce: '',
        bstatus: '1',
        pics: [],
        price: {
          'price1': '','price2': '','price3': '','sprice1': '',
          'sprice2': '','sprice3': '','poundage': '','discount': '',
        },
        bPrice: {
          'price1': '','price2': '','price3': '','price01': '','price02': '','price03': ''
        },
        tips: {'description1': '','description2': '','description3': '','description4': ''},
        sort: 1
      }
    },
    methods: {
      ...mapActions(['addEditTicket','getTicketDetail']),
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
      },
      p(s) {
        return s < 10 ? '0' + s : s
      },
      handleInputConfirm() {
        let d = new Date(this.playtime)
        let time = this.p(d.getHours()) + ':' + this.p(d.getMinutes())
        if (this.dynamicTags) {
          let fler = this.dynamicTags.filter(v => v == time)
          if (fler.length > 0) { this.$message.warning('已有相同场次'); return }
        }
        this.dynamicTags.push(time)
      },
      rowSave (row) {
        let price = /^[1-9]\d{1,4}(\.\d{1,2})?$/
        if (!row.seat_name) { this.$message.warning('请输入位置名称'); return }
        if (!price.test(row.price1) || !price.test(row.price2) || !price.test(row.price3)) {
          this.$message.warning('只能输入10~100000之间的正整数或小数'); return
        }
        row.edit = false
      },
      // 添加座位
      addSeat () {
        let price = /^[1-9]\d{1,4}(\.\d{1,2})?$/
        if (!this.seatName) { this.$message.warning('请输入位置名称'); return }
        if (!price.test(this.price.sprice1) || !price.test(this.price.sprice2) || !price.test(this.price.sprice3)) {
          this.$message.warning('价格只能输入10~100000之间的正整数或小数'); return
        }
        let { sprice1, sprice2, sprice3 } = this.price
        this.tableData.push({seat_name: this.seatName, price1: sprice1, price2: sprice2, price3: sprice3, edit: false})
        this.price.sprice1 = ''; this.price.sprice2 = ''; this.price.sprice3 = ''; this.seatName = ''
      },
      /*校验表单*/
      validateForm () {
        if (!this.ticketName) return { code: false, msg: '请填写门票名称' }
        if (!this.brand) {
          /*验证价格类型是否都填写正确*/
          for (let i = 0; i < this.priceArr.length; i++) {
            let item = this.priceArr[i]
            switch (item.title) {
              case '佣金':
              case '在线立减':
                if (this.price[item.value] < 0) return { code: false, msg: item.title + '不得小于0' }
                break
              default:
                if (!this.$GFUN.isMoneyRight(this.price[item.value])) return { code: false, msg: '请正确填写' + item.title }
            }
          }
        } else {
          let Marr = ['price1','price2','price3','price01','price02','price03']
          for (let i = 0; i < Marr.length; i++) {
            let v = Marr[i];
            if (!this.$GFUN.isMoneyRight(this.bPrice[v])) return {code: false,msg: '活动价格填写有误'}
          }
        }
        /*验证费用包含等信息是否填写*/
        for (let i = 0; i < this.tipArr.length; i++) {
          let item = this.tipArr[i]
          if (!this.tips[item.value]) return { code: false, msg: '请填写' + item.title }
        }
        return { code: true, msg: '表单验证通过' }
      },
      /*采购商提交表单、管理员审核门票*/
      submitForm () {
        //if (this.dynamicTags.length > 0) { if (this.tableData.length == 0) { this.$message.warning('已有场次，请添加座位！'); return } }
        //if (this.tableData.length > 0) { if (this.dynamicTags.length == 0) { this.$message.warning('已有座位，请添加场次！'); return } }
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].edit == true) { this.$message.error('请先保存编辑项'); return }
        }
        let result = this.validateForm()
        if (result.code) {
          this._confirm('确定提交么？',async () => {
            let { description1, description2, description3, description4 } = this.tips
            let { price1, price2, price3 } = this.price
            //let { price1, price3 } = this.price
            let seat_pic = (await UploadImages(this.InsideImgs)).join(',');
            let seat = this.tableData.map((v, index) => {
                return {
                  seat_name: v.seat_name,
                  price1: v.price1,
                  price2: v.price2,
                  price3: v.price3,
                }
            })
            let data = {
                ticket_type: this.ticketType,
                ticket_species: this.ticketSpecie,
                name: this.ticketName,
                description1, description2, description3, description4,
                price1, price2, price3,
                seat_pic,
                scene: this.dynamicTags.join(','),
                seat
            }
            if (this.brand) {
              let { price1, price2, price3, price01, price02, price03} = this.bPrice
              data = { ...data, price1, price2, price3, price01, price02, price03, sort: this.sort }
            }
            if (this.ticketId > 0 && !this.isAdmin) data.ticket_id = this.ticketId
            if (this.isAdmin) {
              let { poundage, discount } = this.price
              data.ticket_id = this.ticketId
              data.poundage = poundage
              data.discount = discount
              data.is_discount = this.value
            }
            if (this.brand) {
              data.pic = (await UploadImages(this.pics)).join(',');
              data.status = this.bstatus; data.species = data.ticket_species; data.onsale_id = data.ticket_id;
              data.content = this.introduce; delete data.ticket_species; delete data.ticket_type; delete data.seat_pic;
              delete data.scene; delete data.ticket_id
            }
            this.addEditTicket(data);
          })
        } else this._alert(result.msg,null,'error')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .price-input {
    appearance: none;
    border: none;
    width: 100px;
    height: 30px;
    &:focus {
      outline: none;
    }
  }
  .add{
    border: 1px solid #dee2e6;
    width: 45px;
    height: 45px;
    line-height: 45px;
    border-radius: 5px;
    font-size: 24px;
    color:#dee2e6;
    text-align: center;
    margin-bottom: 1rem;
    cursor: pointer;
  }
  .price-label {
    background: var(--smtc-color-primary);
    color: #fff;
    height: 100%;
    display: inline-block;
  }
</style>
